module.exports = __webpack_public_path__ + "assets/comp-2.5c2828ac69c787280d684c205c90c2cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background/login/comp-2.jpg
// module id = KuoJ
// module chunks = 0